module.exports = __webpack_public_path__ + "static/media/image-3.6c7dd65e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FacebookBusiness/image-3.png
// module id = 431
// module chunks = 0